// extracted by mini-css-extract-plugin
export default {"input":"CompleteDispute_input__VqiHb"};